import { Component, Input } from "@angular/core";
import { ErrorComponentBase } from "../error.decorator";
import { IMenu } from "app/types/menu";

export interface Error500PageComponent extends ErrorComponentBase { }
@Component({
    selector: "error-500-page-component",
    templateUrl: "../error.view.html",
    standalone: false
})
@ErrorComponentBase
export class Error500PageComponent {

  @Input() error: { [key: string]: any };
  @Input() home: IMenu = null;
  @Input() sections: IMenu[] = [];

  code: string = "500";
  subTitle: string = 'Internal Server Error';
  lead: string = `We're having a temporary issue with our system and are working on it. We’ll be up and running again in no time!`

}
